import styled from "styled-components";
import { xs } from "../../../../../../BreakPoints";

export const TopBar = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 0.3rem;
  ${xs({
    gap: "0.1rem",
  })};
`;

export const LeftWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 25%;
  min-width: 200px;
  gap: 1rem;
`;

export const RightWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 25%;
  min-width: 200px;
`;

export const ItemTopBarWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const InviteButton = styled.button`
  display: flex;
  border: none;
  height: 2rem;
  color: white;
  padding: 0rem 1rem;
  align-items: center;
  gap: 0.5rem;
  border-radius: 3px;
  background-color: #0079bf;
  cursor: pointer;
  transition: 250ms ease;
  &:hover {
    background-color: #00599f;
  }
`;

export const TextSpan = styled.span`
  font-size: 0.85rem;
  font-weight: 600;
  ${xs({
    display: "none",
  })}
`;

export const BoardNameInput = styled.input`
  height: 1.75rem;
  background-color: rgba(255, 255, 255, 0.25);
  border: none;
  border-radius: 3px;
  font-size: 1.1rem;
  text-align: center;

  min-width: 6.5rem;
  max-width: 14rem;
  width: ${(props) => Math.min(props.value.length * 0.75, 14) + "rem"};

  font-weight: 600;
  color: white;
  outline: 2px solid rgba(255, 255, 255, 0.25);
  transition: 200ms ease;
  cursor: pointer;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  &:hover {
    background-color: rgba(255, 255, 255, 0.45);
  }

  &:focus {
    background-color: white;
    outline: 2px solid #0079bf;
    color: black;
    cursor: text;
  }

  &::placeholder {
    color: #d0d0d0;
  }

  ${xs({
    maxWidth: "8rem",
  })}
`;
